import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import { UserTick, DocumentText } from "iconsax-reactjs";

import * as APIDashboard from "../../../../services/nps/functions";

import { ReactComponent as PersonCheckIcon } from "../../../../build/images/nps-dashboard-icons/person_check.svg";
import { ReactComponent as EditDocumentIcon } from "../../../../build/images/nps-dashboard-icons/edit_document.svg";

import "./nps-date-two.css";
import Paperplane from "../../../Loading/Paperplane";

export default function NpsDateTwo() {
  const filtersDashboard = useSelector((state) => state.npsfilters);
  const cardsOfQualityDash = useSelector((state) => state.cardsOfQualityDash);

  const [initialDate, setInitialDate] = useState(filtersDashboard.datestart);
  const [finalDate, setFinalDate] = useState(filtersDashboard.dateend);
  const [dataAtend, setDataAtend] = useState({
    atendRealizados: 0,
    clientesAtend: 0,
    atendimentos: 0,
  });
  const [dataSearch, setDataSearch] = useState({
    mudancaPerfil: 0,
    notasAlteradas: 0,
    pesquisasTrat: 0,
  });
  const [dispareFilter, setDispareFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);

  async function getServicesPerformed() {
    setLoading(true);

    const response = await APIDashboard.getServicesPerformed(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.units.map((option) => option.id).join(),
      filtersDashboard.questionsNPS.map((option) => option.id).join(),
      filtersDashboard.questionsCSAT.map((option) => option.id).join(),
      filtersDashboard.channels.map((option) => option.id).join(),
    );

    if (response && response.status === 200) {
      const data = response.data;

      setDataAtend({
        atendRealizados: data[0].qtde_procedimentos
          ? data[0].qtde_procedimentos
          : 0,
        clientesAtend: data[0].clientes_atendidos,
        atendimentos: data[0].atendimento,
      });
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde.",
      );
      //   Toast(
      //     "Falha, não foi possível carregar as informações!",
      //     "Verifique sua conexão e tente novamente mais tarde",
      //     "error"
      //   );
    }
    setLoading(false);
  }

  async function getResearchHandled() {
    setLoadingSearch(true);

    const response = await APIDashboard.getResearchHandled(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.units.map((option) => option.id).join(),
      filtersDashboard.questionsNPS.map((option) => option.id).join(),
      filtersDashboard.questionsCSAT.map((option) => option.id).join(),
      filtersDashboard.channels.map((option) => option.id).join(),
    );

    if (response && response.status === 200) {
      const data = response.data;

      setDataSearch({
        mudancaPerfil: data[0].mudanca_perfil,
        notasAlteradas: data[0].notas_alteradas,
        pesquisasTrat: data[0].pesquisas_tratadas,
      });
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde.",
      );
      //   Toast(
      //     "Falha, não foi possível carregar as informações!",
      //     "Verifique sua conexão e tente novamente mais tarde",
      //     "error"
      //   );
    }
    setLoadingSearch(false);
  }

  useEffect(() => {
    if (!cardsOfQualityDash.card5) return;

    if (!dispareFilter || filtersDashboard.active) {
      getServicesPerformed();
      if (!dispareFilter) setDispareFilter(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersDashboard, cardsOfQualityDash.card5]);

  useEffect(() => {
    if (!cardsOfQualityDash.card6) return;

    if (!dispareFilter || filtersDashboard.active) {
      getResearchHandled();
      if (!dispareFilter) setDispareFilter(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersDashboard, cardsOfQualityDash.card6]);

  return (
    (cardsOfQualityDash.card5 || cardsOfQualityDash.card6) && (
      <section className="nps-date-two-quality">
        {cardsOfQualityDash.card5 && (
          <div className="card-container-one">
            {loading ? (
              <Paperplane className="nps-date-two__loading" />
            ) : (
              <>
                <header className="nps-date-two__header">
                  <div className="cards-headers">
                    <h4>Atendimentos</h4>
                  </div>
                </header>

                <div className="card-container">
                  <div className="services-performed">
                    <span className="services-performed__icon">
                      <UserTick variant="Outline" color="#455CC7" />
                    </span>

                    <span className="services-performed__text">
                      <h1 className="services-performed__text__number">
                        {dataAtend.atendRealizados}
                      </h1>

                      <h6 className="services-performed__text__information">
                        Atendimentos realizados
                      </h6>
                    </span>
                  </div>

                  <div className="customers-served">
                    <h1 className="customers-served__number">
                      {dataAtend.clientesAtend}
                    </h1>

                    <h6 className="customers-served__information">
                      Clientes atendidos
                    </h6>
                  </div>

                  <div className="services">
                    <h1 className="services__number">
                      {dataAtend.atendimentos}
                    </h1>

                    <h6 className="services__information">Atendimentos</h6>
                  </div>
                </div>
              </>
            )}
          </div>
        )}

        {cardsOfQualityDash.card6 && (
          <div className="card-container-two">
            {loadingSearch ? (
              <Paperplane className="nps-date-two__loading" />
            ) : (
              <>
                <header className="nps-date-two__header">
                  <div className="cards-headers">
                    <h4>Tratativas</h4>
                  </div>
                </header>

                <div className="card-container">
                  <div className="research-handled">
                    <span className="research-handled__icon">
                      <DocumentText variant="Outline" color="#455CC7" />
                    </span>

                    <span className="research-handled__text">
                      <h1 className="research-handled__text__number">
                        {dataSearch.pesquisasTrat}
                      </h1>

                      <h6 className="research-handled__text__information">
                        Pesquisas tratadas
                      </h6>
                    </span>
                  </div>

                  <div className="changed-notes">
                    <h1 className="changed-notes__number">
                      {dataSearch.notasAlteradas}
                    </h1>

                    <h6 className="changed-notes__information">
                      Notas alteradas
                    </h6>
                  </div>

                  <div className="profile-change">
                    <h1 className="profile-change__number">
                      {dataSearch.mudancaPerfil}
                    </h1>

                    <h6 className="profile-change__information">
                      Mudança de perfil
                    </h6>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </section>
    )
  );
}
